import { Link } from 'react-router';
import { buildMeta, breadcrumbSchema, localBusinessSchema } from '~/lib/seo';
import { SITE } from '~/data/site';

export function meta() {
  return buildMeta({
    title: 'Contact us',
    description: `Email ${SITE.contact.email} or send a quote request. Commercial cleaning across Tampa Bay, based in Brandon.`,
    path: '/contact',
    jsonLd: [
      breadcrumbSchema([
        { name: 'Home', url: '/' },
        { name: 'Contact', url: '/contact' },
      ]),
      localBusinessSchema(),
    ],
  });
}

export default function Contact() {
  return (
    <>
      <section className="hero dusk grain">
        <div className="shell">
          <div className="hero-inner">
            <p className="eyebrow-pill">Contact</p>
            <h1>Write to us. We answer fast.</h1>
            <p className="lede">
              Roughly 78% of people who buy a service like this buy from whoever responded first. We
              would rather that be us, so email gets answered the same business day.
            </p>
            <div className="btn-row">
              <Link to="/quote" className="btn btn-primary">
                Get a quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="grid-3">
            <div className="card">
              <h4>Email</h4>
              <p>
                <a href={`mailto:${SITE.contact.email}`}>{SITE.contact.email}</a>
              </p>
              <p className="small">
                We answer the same business day. {SITE.hours.office}
              </p>
            </div>

            <div className="card">
              <h4>Where we are</h4>
              <p>{SITE.contact.address}</p>
              <p className="small">Working across {SITE.serviceArea}.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-ground">
        <div className="shell-narrow stack">
          <h2>What to have ready</h2>
          <p>Any of these speeds the first call up. None of them are required.</p>
          <ul className="check">
            <li>Roughly how big the space is, in square feet.</li>
            <li>How many nights a week you want us.</li>
            <li>What is going wrong with your current arrangement, if anything.</li>
            <li>Whether you need a certificate of insurance, and to what limits.</li>
          </ul>
        </div>
      </section>

      <section className="dawn">
        <div className="shell">
          <div className="cta-inner">
            <h2>Would rather write it down?</h2>
            <p>Seven fields, and we call you back the same day.</p>
            <div className="btn-row">
              <Link to="/quote" className="btn btn-primary">
                Get a quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
